import React from "react";

import Spinner from "./Spinner";

export default function LoadingModal(props) {
	return (
		<div className="loading-modal">
			<div className="loading-modal__spinner">
				<div className="spinner"></div>
			</div>
			<p>{props.text}</p>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/js/common/components/LoadingModal.js